import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { Anchor } from 'components/Anchor'
import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'

import type { IAssessment } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IAssessment & { className?: string }
>(({ title, subtitle, kelas, className, id, trackerWidgetData }, ref) => {
  const url = getNonGeneralWidgetUrl({
    type: NON_GENERAL_WIDGET.Assessment,
    id,
  })
  return (
    <Anchor href={url}>
      <a href={url} className="last:mb-0 mb-2 block">
        <div
          className={clsx(
            'rounded border border-subdued p-3 mb-2 cursor-pointer',
            className
          )}
          ref={ref}
          onClick={() =>
            trackWidgetClick({
              ...trackerWidgetData,
              widgetValue: {
                ...trackerWidgetData.widgetValue,
                url,
              },
            })
          }
        >
          <Text className="mb-1" variant="helper" color="disabled">
            Aktivitas • {kelas}
          </Text>
          <Text className="mb-1 line-clamp-2" variant="heading-sm">
            {title}
          </Text>
          <Text variant="body-sm" className="mb-0 mt-[2px] line-clamp-2">
            {subtitle}
          </Text>
        </div>
      </a>
    </Anchor>
  )
})

BaseWidget.displayName = 'Assessment'

export default BaseWidget
